// @flow
import React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { MQ } from '@rover/kibble/styles';
import SingleSelectButtonGroup from '@rover/react-lib/components/formFields/SingleSelectButtonGroup';
import LabelAndErrorFormGroup, {
  type Props as LabelAndErrorFormGroupProps,
} from '@rover/react-lib/components/utils/LabelAndErrorFormGroup';
import { SexInfoConstants } from '@rover/shared/js/constants/translation';

const StyledSingleSelectButtonGroup: StyledComponent<
  React$ElementConfig<typeof SingleSelectButtonGroup>,
  {},
  any
> = styled(SingleSelectButtonGroup)`
  height: 40px;
  div:focus {
    outline: 0;
  }
`;

const DogSexFormGroup = (props: LabelAndErrorFormGroupProps) => (
  <LabelAndErrorFormGroup {...props} InputComponent={StyledSingleSelectButtonGroup} />
);

const StyledDogSexFormGroup: StyledComponent<
  React$ElementConfig<typeof DogSexFormGroup>,
  {},
  any
> = styled(DogSexFormGroup)`
  flex: 1 0 100%;

  ${MQ.NOT_XS} {
    flex: 0 1 210px;
  }
`;

const buttons = [
  {
    value: 'm',
    subtitle: SexInfoConstants.labelSexM,
    'data-qa-id': 'button-dog-sex-male',
  },
  {
    value: 'f',
    subtitle: SexInfoConstants.labelSexF,
    'data-qa-id': 'button-dog-sex-female',
  },
];

export type Props = {
  value: string,
  onChange: (string) => void,
};

const EditPetFormSexField = ({ value, onChange }: Props) => (
  <StyledDogSexFormGroup name="gender" value={value} buttons={buttons} onChange={onChange} />
);

export default EditPetFormSexField;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/SexInfo/EmergencyFormSexField.jsx